<template>
  <div>
    <FormLayout
      :tabs="this.tabs"
      :cardInfo="this.cardInfo"
      :leftAction="this.leftAction"
      :leftLinkNavigation="this.leftLinkNavigation"
      :onChangeTab="onChangeTabIndex"
    ></FormLayout>
  </div>
</template>

<script>
import Vue from "vue";
import FormLayout from "../../../layouts/FormLayout.vue";
import { ServiceType } from "../../../static-data/ServiceType";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("iss-information", () =>
  import("../components/visualization/ISSInformation.vue")
);

Vue.component("inss-information", () =>
  import("../components/visualization/InssInformation.vue")
);

Vue.component("information-alvara", () =>
  import("../components/visualization/InformationAlvara.vue")
);

export default {
  components: {
    FormLayout,
  },
  data: function() {
    return {
      currentTabIndex: 0,
      leftAction: {
        text: "Cadastro",
        onClick: this.leftActionClickHandler,
      },
      leftLinkNavigation: this.leftHistoryNavigation,
      cardInfo: {
        icon: "script-text-outline.svg",
        title: "Imposto e alvará",
        description: "Consulte e cadastre opções de impostos e alvará.",
      },
      tabs: [
        {
          title: "Informações de INSS",
          formComponent: "inss-information",
          serviceType: ServiceType.InssInformation,
        },
        {
          title: "Informações de ISS",
          formComponent: "iss-information",
          serviceType: ServiceType.IssInformation,
        },
        {
          title: "Alvará",
          formComponent: "information-alvara",
          serviceType: ServiceType.PermitInformation,
        },
      ],
    };
  },
  methods: {
    onChangeTabIndex(newValue) {
      this.currentTabIndex = newValue;
    },
    leftActionClickHandler() {
      this.$router.push(RoutesPaths.register.rootName());
    },
    leftHistoryNavigation() {
      this.$router.push({
        path: RoutesPaths.requestHistory.rootName(),
        params: {
          serviceType: this.tabs[this.currentTabIndex].serviceType,
        },
      });
    },
  },
};
</script>
